import { clone, mergeDeepWith } from 'ramda';
import { TDeviceFormFactor } from 'js/hooks/device/store/types';

import { IGamesFeed, IGamesFeedResponse, TGamesGridLayout, TGamesFeedCategory } from '../../types';

const getLayoutTilesArray = (rawLayout: string): string[] => {
    // we need to change order of games shown in the layout to be from top to bottom instead left to right
    const layoutArray = rawLayout
        .replace(/" "/g, ';')
        .replace(/"/g, '')
        .replace(/ /g, '|')
        .split(';');

    const resultMap:string[][] = [];

    layoutArray.forEach((row) => {
        row.split('|').forEach((id, index) => {
            resultMap[index] ? resultMap[index].push(id) : resultMap[index] = [id];
        });
    });

    const layoutTiles = new Set(resultMap.flat());

    return Array.from(layoutTiles);
};

const getGridLayoutTilesArray = (rawLayout: string): string[] => {
    const layoutArray = [rawLayout.replace(/"/g, '').split(' ')];
    const layoutTiles = new Set(layoutArray.flat());

    return Array.from(layoutTiles);
};

export const parseGamesFeed = ({ gamesFeed, formFactor, excludedGameCodes } : {
    gamesFeed: IGamesFeedResponse;
    formFactor: TDeviceFormFactor;
    excludedGameCodes: string[];
}): IGamesFeed => {
    const gamesGridLayouts = Object.keys(gamesFeed.gamesGridLayouts).reduce((layout, name) => {
        layout[name] = {
            ...gamesFeed.gamesGridLayouts[name],
            bordersCount:  Number(gamesFeed.gamesGridLayouts[name].columns) - 1,
            layoutTiles: getLayoutTilesArray(gamesFeed.gamesGridLayouts[name].layout),
            gridLayoutTiles: getGridLayoutTilesArray(gamesFeed.gamesGridLayouts[name].layout)
        };

        return layout;
    }, {} as { [key: string]: TGamesGridLayout });

    const gamesFeedCategories = gamesFeed.gamesFeedCategories.map((category) => {
        const deviceCategoryConfiguration = category[`${formFactor}CategoryConfiguration`];

        return {
            ...category,
            categoryConfiguration: {
                ...deviceCategoryConfiguration,
                categoryGames: deviceCategoryConfiguration.categoryGames
                    .filter((gameCode) => !excludedGameCodes.includes(gameCode)),
                categoryGameGridLayout: gamesGridLayouts[deviceCategoryConfiguration.categoryGameGridLayout],
                viewMoreGameGridLayout: gamesGridLayouts[deviceCategoryConfiguration.viewMoreGameGridLayout]
            }
        };
    }, [] as TGamesFeedCategory[]);

    return mergeDeepWith(clone, { gamesFeedCategories, gamesGridLayouts }, gamesFeed);
};
